import styled from 'styled-components';

export const Wrapper = styled.div`
  width: ${({ theme }) => theme.width};
  max-width: 100%;
  height: ${({ theme }) => theme.height};
`;

export const Input = styled.textarea<any>`
  height: 100%;
  background: transparent;
  border: none;
  font-size: ${({ theme }) => theme.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight};
  line-height: ${({ theme }) => theme.lineHeight};
  color: ${({ theme }) => theme.color};
  outline: none;
  overflow: hidden;
  resize: none;
  width: 100%;
  padding: 2px 8px;

  ::placeholder {
    color: ${({ theme }) => theme.color};
  }
`;
